export default "__VITE_ASSET__ByfO8Gtd__"